/**
 * The LBA "Flugdurchführungsplan VFR" (fsm 1/87) template: field map and
 * conventions. Coordinates were extracted from the original PDF's vector
 * content and visually verified cell-by-cell against renders.
 *
 * Field id conventions (mirror the form's own numbering):
 *   datum, von, nach, lfz_muster, lfz_kennz              header (V1)
 *   freigaben_1..4                                        B1
 *   fq_{dep,dest}_{ground,twr,info}                       V2
 *   atis{1,2}_{station,code,rwy,tl,zeit,wind,sicht,wolken,temp,qnh,tendenz}   B6
 *   etd, atd, eta, ata, ss, safe_time                     V3/B2/P19/V4/P27 (d4 time fields)
 *   cp{1..13}_{name,freq}, cp{2..13}_{eto,ato}            P1/P2/P3, B3/B4
 *   leg{1..12}_{safealt,alt,tas,wind,tc,wca,var,mh,mc,dist,rest_dist,gs,time,rest_time,remark}
 *   total_dist, total_time                                P14/P18
 *   alt_*                                                 P20 alternate row
 *   fs_beratung_1..6, wetter_1..6, gafor, gafor_check, gafor_bis     V5/V6
 *   aip_{p1,p2f,p20}_*                                    V7
 *   fuel_*, mb_*, tl_*                                    P22–P35
 */
import fields from './lba-fields.json' with { type: 'json' };
export const LBA_FIELDS = fields;
/** Field ids stamped in bold on the LBA form (the P14/P18 totals boxes). */
export const LBA_BOLD_FIELDS = ['total_dist', 'total_time'];
/** Every field id the LBA template knows. */
export const LBA_FIELD_IDS = Object.freeze(Object.keys(LBA_FIELDS));
/** True if the id is one the LBA template can render. */
export const isLbaField = (id) => Object.prototype.hasOwnProperty.call(LBA_FIELDS, id);
//# sourceMappingURL=lba.js.map